import { render, staticRenderFns } from "./GraduatesListItem.vue?vue&type=template&id=01892fa4&"
import script from "./GraduatesListItem.vue?vue&type=script&lang=js&"
export * from "./GraduatesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports